import { Injectable } from '@angular/core';
import { PointsService } from './points.service';
import { ProcedureControlService } from './procedure-control.service';
import { ToolsControlService } from './tools-control.service';

@Injectable({
  providedIn: 'root'
})
export class ProceduresFilterService {

  active : boolean = false;
  fullScreenMode : boolean = false;
  loading : boolean = false;

  constructor(private toolsService : ToolsControlService,
    private procedureController : ProcedureControlService,
    private pointsService : PointsService) {

     }

  openWindow():void {
    this.active = true;
    this.toolsService.navigationOnTop = true;
    this.procedureController.setAirportsCoordinatePoint();
    this.getProceduresFromDatabase();
  }

  getProceduresFromDatabase() : void {
    this.loading = true;
    this.pointsService.getProcedures().subscribe((results) => {
      this.procedureController.procedures = results;
      this.loading = false;
    });
  }
}
